import { render } from "./HzbaGroupCtas.vue?vue&type=template&id=0c063abf&ts=true"
import script from "./HzbaGroupCtas.vue?vue&type=script&lang=ts"
export * from "./HzbaGroupCtas.vue?vue&type=script&lang=ts"

import "./HzbaGroupCtas.vue?vue&type=style&index=0&id=0c063abf&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__